import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        // Bind
        this.onChangeBind = this.onChange.bind(this)

        // UI
        this.$images = this.$('image')
        this.$ctas = this.$('cta')
        this.$prices = this.$('price')
        this.$sales = this.$('sale')
        this.$links = this.$('link')
        this.$radios = this.$('radio')

        // Current value
        this.currentValue = ''
    }

    init() {
        this.bindEvents()
        this.setDefaultValue()
    }

    destroy() {
        super.destroy()
        this.unbindEvents()
    }


    bindEvents() {
        for (let index = 0; index < this.$radios.length; index++) {
            const $radio = this.$radios[index];
            $radio.addEventListener('change', this.onChangeBind)
        }
    }

    unbindEvents() {
        for (let index = 0; index < this.$radios.length; index++) {
            const $radio = this.$radios[index];
            $radio.removeEventListener('change', this.onChangeBind)
        }
    }

    onChange(e) {
        let currentValue = ''
        const $currentRadios = [...this.$radios].filter($radio => $radio.checked)
        
        for (let index = 0; index < $currentRadios.length; index++) {
            const $currentRadio = $currentRadios[index];
            
            if (index > 0) {
                currentValue += `-${$currentRadio.value}`
            } else {
                currentValue += $currentRadio.value
            }
        }
        this.currentValue = currentValue
        this.updateContent()
    }

    setDefaultValue() {
        let currentValue = ''
        const $currentRadios = [...this.$radios].filter($radio => $radio.checked)

        for (let index = 0; index < $currentRadios.length; index++) {
            const $currentRadio = $currentRadios[index];
            
            if (index > 0) {
                currentValue += `-${$currentRadio.value}`
            } else {
                currentValue += $currentRadio.value
            }
        }
        this.currentValue = currentValue
        this.updateContent()
    }

    updateContent() {
        // Images
        for (let index = 0; index < this.$images.length; index++) {
            const $image = this.$images[index];

            if ($image.dataset.variant === this.currentValue) {
                $image.classList.remove('is-hidden')
            } else {
                $image.classList.add('is-hidden')
            }
        }

        // Ctas
        for (let index = 0; index < this.$ctas.length; index++) {
            const $cta = this.$ctas[index];

            if ($cta.dataset.variant === this.currentValue) {
                $cta.classList.remove('is-hidden')
            } else {
                $cta.classList.add('is-hidden')
            }
        }

        // Prices
        for (let index = 0; index < this.$prices.length; index++) {
            const $price = this.$prices[index];

            if ($price.dataset.variant === this.currentValue) {
                $price.classList.remove('is-hidden')
            } else {
                $price.classList.add('is-hidden')
            }
        }

        // Sales
        for (let index = 0; index < this.$sales.length; index++) {
            const $sale = this.$sales[index];

            if ($sale.dataset.variant === this.currentValue) {
                $sale.classList.remove('is-hidden')
            } else {
                $sale.classList.add('is-hidden')
            }
        }

        // Links
        for (let index = 0; index < this.$links.length; index++) {
            const $link = this.$links[index];

            if ($link.dataset.variant === this.currentValue) {
                $link.classList.remove('is-hidden')
            } else {
                $link.classList.add('is-hidden')
            }
        }
    }
}
